import { render, staticRenderFns } from "./OrderSign.vue?vue&type=template&id=fdfce2d4&scoped=true&"
import script from "./OrderSign.vue?vue&type=script&lang=js&"
export * from "./OrderSign.vue?vue&type=script&lang=js&"
import style0 from "./OrderSign.vue?vue&type=style&index=0&id=fdfce2d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfce2d4",
  null
  
)

export default component.exports